export enum SpareStockStatusEnum {
    OPEN = 'OPEN',
    ALLOCATED = 'ALLOCATED',
    CONSUMED = 'CONSUMED'
}